var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdf-preview-container" }, [
    _vm.pdfUrl
      ? _c("div", { staticClass: "pdf-box" }, [
          !_vm.isLoadError
            ? _c("div", {
                ref: "pdfCanvasWrap",
                staticClass: "pdf-canvas-wrap",
                on: {
                  touchstart: _vm.handleTouchStart,
                  touchmove: _vm.handleTouchMove,
                  touchend: _vm.handleTouchEnd,
                  touchcancel: _vm.handleTouchEnd,
                },
              })
            : _vm._e(),
          _vm.isLoading && !_vm.isLoadError
            ? _c("div", { staticClass: "pdf-loading" }, [_vm._v("加载中...")])
            : _vm._e(),
          _vm.isLoadError
            ? _c("div", { staticClass: "pdf-error-tip" }, [
                _vm._v("暂不支持预览该PDF，请检查文件是否有效"),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "pdf-placeholder" }, [_vm._v("暂无PDF文件")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }